import { apiClient } from './client';

export function listAll () {
  return apiClient.get('/feature-flags');
}

export function listForShop (shopId: number | string) {
  return apiClient.get(`/feature-flags/shop/${shopId}`);
}

export function isActive (featureKey: string, shopId: number | string) {
  return apiClient.get(`/feature-flags/${featureKey}/${shopId}/is-active`);
}

export function activate (featureKey: string, shopId: number | string) {
  return apiClient.post(`/feature-flags/${featureKey}/${shopId}/activate`);
}

export function deactivate (featureKey: string, shopId: number | string) {
  return apiClient.post(`/feature-flags/${featureKey}/${shopId}/deactivate`);
}
